import React from 'react';

import SitePreviewGate from './SitePreviewGate';
import { MantineProviderWrapper } from '../../providers';

type RootWrapperProps = {
  children: React.ReactNode;
};
function RootWrapper({ children }: RootWrapperProps) {
  return (
    <MantineProviderWrapper>
      <SitePreviewGate>{children}</SitePreviewGate>
    </MantineProviderWrapper>
  );
}
// Gatsby wrapRootElement function
export const wrapRootElement = ({ element }: { element: React.ReactNode }) => (
  <RootWrapper>{element}</RootWrapper>
);
export default RootWrapper;
